// extracted by mini-css-extract-plugin
export default {"BooksGrid":"BooksGrid_BooksGrid__Wt51O","BooksGrid__Grid":"BooksGrid_BooksGrid__Grid__mbCmy","BooksGrid__Ad":"BooksGrid_BooksGrid__Ad__PaZMO"};